import { writable } from 'svelte/store'
import type { Dialog } from './lib/native-messaging/dialog'

export const dialog = writable<null | Dialog>(null)

export const isGlobalLoaderVisible = writable(false)
